import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "lucky-spin-reward-popup"
};
const _hoisted_2 = {
  class: "popup-content"
};
const _hoisted_3 = {
  class: "lucky-rewards flex"
};
const _hoisted_4 = {
  class: "reward-item"
};
const _hoisted_5 = {
  class: "reward-icon-bg"
};
const _hoisted_6 = {
  key: 0,
  class: "reward-amount"
};
const _hoisted_7 = {
  key: 1,
  class: "reward-amount"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "symbol"
}, "+", -1);
const _hoisted_9 = {
  class: "reward-item"
};
const _hoisted_10 = {
  class: "reward-icon-bg"
};
const _hoisted_11 = {
  class: "reward-amount"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "symbol"
}, "=", -1);
const _hoisted_13 = {
  class: "reward-item"
};
const _hoisted_14 = {
  class: "reward-icon-bg"
};
const _hoisted_15 = {
  key: 0,
  class: "reward-amount"
};
const _hoisted_16 = {
  key: 1,
  class: "reward-amount"
};
const _hoisted_17 = {
  key: 2,
  class: "reward-amount"
};
const _hoisted_18 = {
  class: "tip-title"
};
const _hoisted_19 = {
  class: "tip-content"
};
import { computed } from 'vue';
export default {
  __name: 'Reward',
  props: ['reward'],
  emits: ['onClose'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const tipType = computed(() => {
      let type = props.reward.rewardType;
      switch (props.reward.rewardType) {
        case 'random_amount':
          type = 'amount';
          break;
        case 'withdraw_now':
          type = 'withdraw';
          break;
        default:
          break;
      }
      return type;
    });
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
        class: "full-page",
        show: true,
        "close-on-click-overlay": false,
        "lock-scroll": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "popup-main",
          onClick: _cache[0] || (_cache[0] = $event => emit('onClose'))
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [__props.reward.useDual ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_van_image, {
          class: "reward-icon",
          src: __props.reward.picture
        }, null, 8, ["src"])]), tipType.value === 'amount' ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.reward.base) + "P", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.reward.base), 1))]), _hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_van_image, {
          class: "reward-icon",
          src: __props.reward.dualPicture
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_11, _toDisplayString(__props.reward.dualName), 1)]), _hoisted_12], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_van_image, {
          class: "reward-icon",
          src: __props.reward.picture
        }, null, 8, ["src"])]), tipType.value === 'amount' ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(__props.reward.value) + "P", 1)) : tipType.value === 'points' ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(__props.reward.value), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(__props.reward.name), 1))])]), _createVNode(_component_van_image, {
          class: "divider",
          src: require('@/assets/img/lucky-spin/reward/divider.png')
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t(`luckyWheel.reward.${tipType.value}.title`)), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t(`luckyWheel.reward.${tipType.value}.content`).format({
          amount: __props.reward.value
        })), 1)])])]),
        _: 1
      })]);
    };
  }
};